import { DOCUMENT } from '@angular/common';
import { Component, HostListener, Inject, ViewEncapsulation } from '@angular/core';
import { ArticleService } from 'src/app/services/article.service';
import { Page as P, Section as S, SubSection as SS } from 'shared/location-enums';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
    selector: 'contact-us-contact-center',
    templateUrl: './contact-us-contact-center.component.html',
    styleUrls: ['./contact-us-contact-center.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class Co2ContactCenterComponent {
    private readonly desktopBreakpoint = 992;
    private readonly mobileClampLines = 8;
    private readonly unclampedLines = 1000;

    mainTitle: string;
    mainBody: string;
    mainBodyMaxLines = this.unclampedLines;

    formTitle: string;
    formBody: string;
    buttonTitle: string;
    buttonUrl: SafeUrl;

    requestFormTitle: string;
    requestFormBody: string;
    requestButtonTitle: string;
    requestButtonUrl: SafeUrl;

    constructor(private articleService: ArticleService, private sanitizer: DomSanitizer, @Inject(DOCUMENT) private document: Document) {
        this.setMainBodyMaxLines();

        const mainKa = articleService.getOne(P.contactUs, S.contactCenter, undefined, 1);

        this.mainTitle = mainKa.title;
        this.mainBody = mainKa.bodyText;

        const contactFormLink = articleService.getOne(P.contactUs, S.contactCenter, undefined, 4);
        this.formTitle = contactFormLink.title;
        this.formBody = contactFormLink.bodyText;

        const contactFormButtonKa = articleService.getOne(P.contactUs, S.contactCenter, undefined, 5);
        this.buttonTitle = contactFormButtonKa.title;

        const contactFormButtonUrlKa = articleService.getOne(P.contactUs, S.contactCenter, SS.contactUsContactFormButton);
        this.buttonUrl = this.sanitizer.bypassSecurityTrustUrl(contactFormButtonUrlKa.bodyText);

        const requestFormButtonKa = articleService.getOne(P.contactUs, S.contactCenter, SS.requestForm);
        this.requestFormTitle = requestFormButtonKa.title;
        this.requestFormBody = requestFormButtonKa.bodyText;

        const requestFormButtonUrlKa = articleService.getOne(P.contactUs, S.contactCenter, SS.requestFormButton);
        this.requestButtonTitle = requestFormButtonUrlKa.title;
        this.requestButtonUrl = this.sanitizer.bypassSecurityTrustUrl(requestFormButtonUrlKa.bodyText);
    }

    @HostListener('window:resize')
    onWindowResize() {
        this.setMainBodyMaxLines();
    }

    private setMainBodyMaxLines() {
        const width = this.document.defaultView?.innerWidth ?? this.desktopBreakpoint;
        this.mainBodyMaxLines = width >= this.desktopBreakpoint ? this.unclampedLines : this.mobileClampLines;
    }
}
